import styled from 'styled-components'

export const StyledAgendaEventReplacedName = styled.span`
    text-decoration: line-through;
    opacity: 0.6;
`
